// Banner that surfaces universal chemistry-safety violations (Ca+phosphate
// adjacency, biological-before-pH, missing pH adjustment w/ unknown
// alkalinity). The AI emits these via flag_chemistry_violation; the manual-
// mode engine emits them via EnforceSafetyRails. Either source feeds the
// same shape, so this banner is source-agnostic.

export type SafetyViolation = {
  kind: string;
  detail: string;
  step_index?: number;
};

const KIND_LABEL: Record<string, string> = {
  ca_phosphate_adjacency: "Calcium + phosphate adjacent",
  biological_before_ph: "Biological before pH adjuster",
  missing_ph_adjust_unknown_alkalinity:
    "Missing pH adjuster + unknown source-water alkalinity",
};

export function SafetyViolationBanner({
  violations,
}: {
  violations: SafetyViolation[];
}) {
  if (!violations || violations.length === 0) return null;
  return (
    <div
      role="alert"
      className="rounded-md border border-amber-500/40 bg-amber-500/10 px-4 py-3 text-sm"
    >
      <p className="font-medium text-amber-900 dark:text-amber-200">
        {violations.length === 1
          ? "1 chemistry safety violation"
          : `${violations.length} chemistry safety violations`}
      </p>
      <ul className="mt-2 space-y-1">
        {violations.map((v, i) => (
          <li key={i} className="text-amber-900/90 dark:text-amber-100/90">
            <span className="font-medium">
              {KIND_LABEL[v.kind] ?? v.kind}
            </span>
            {v.step_index !== undefined && v.step_index >= 0 && (
              <span className="text-xs text-muted-foreground">
                {" "}
                · step {v.step_index + 1}
              </span>
            )}
            <span> — {v.detail}</span>
          </li>
        ))}
      </ul>
    </div>
  );
}
